<template>
  <v-card height="412" elevation="0">
    <v-list class="branded-background">
      <v-list-tile avatar>
        <v-icon color="white">playlist_play</v-icon>
        <v-list-tile-content>
          <v-list-tile-title class="modal-title">
            <span class="text-white text-truncate-popover">Monitor "{{playlist.name}}"</span>
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <v-divider></v-divider>
    <v-card elevation="0" v-if="playlistModalLoading" height="300">
      <v-container  class="loader-popover">
        <v-progress-circular indeterminate size=50 :width="5"></v-progress-circular>
      </v-container>
    </v-card>
    <v-card elevation="0"color="white" v-else>
      <div>
        <el-table
        :data="classes.data"
        height="300px"
        :row-class-name="assignTableClass"
        :show-header="false"
        >
          <el-table-column
            prop=""
            label=""
            width="50">
            <template slot-scope="scope">
              <div class="row-center">
                <v-icon v-if="classes.lmsType" :color="scope.row.default_color">folder</v-icon>
                <v-icon v-else :color="scope.row.default_color">folder_shared</v-icon>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="Class Name"
            width="350"
            >
          </el-table-column>
          <el-table-column
            prop=""
            align="center"
            label="Date Picker"
            width="400">
            <template slot-scope="scope">
              <v-btn v-if="isPlaylistAssigned(scope.row)" class='branded-background text-white' @click="monitorHotlink({ playlist, section: scope.row })">Monitor</v-btn>
              <v-btn v-if="!isPlaylistAssigned(scope.row) && !scope.row.lmsType" flat text class='branded-text' @click="setDashModal({ type: 'playlistAssign', playlist })">Assign Playlist</v-btn>
              <span v-if="!isPlaylistAssigned(scope.row) && scope.row.lmsType">Please assign Playlist from {{scope.row.lmsType}}</span>
            </template>
          </el-table-column>
          <template slot="empty">
            <h1>No Classes. Create a class before monitoring bulb.</h1>
          </template>
        </el-table>
      </div>
    </v-card>
    <v-divider></v-divider>
    <v-card-actions class="row-space" style="height:56px">
      <v-btn flat class="branded-grey" @click="setDashModal(null)">Close</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
/* global _ */
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import _ from 'lodash';

export default {
  name: 'PlaylistMonitor',
  props: [
    'playlist', 
  ], 
  data() {
    return {
    };
  },
  computed: {
    ...mapState('instructors', [
      'playlistAssignedDates',
      'playlistModalLoading',
    ]),
    ...mapGetters('instructors', [
      'classes',
      'instructorAjaxing',
      'queryParamsInstructors',
    ]),
    //functions to create css class
    assignTableClass: function(row){
      //assign class table has no borders
      if(this.queryParamsInstructors.section_id === ''){
        return 'no-border padding-left';
      } else {
        if(row.row.id === this.queryParamsInstructors.section_id){
          return 'no-border padding-left';
        } else {
          return 'display-none';
        }
      }
    },
  },
  methods: {
    ...mapActions('instructors', [
      'getPlaylistMonitorData',
    ]),
    ...mapMutations([
      'setDashModal',
    ]),
    isPlaylistAssigned(section) {
      return _.find(this.playlistAssignedDates, { 'sectionId': section.id });
    },
    monitorHotlink(data) {
      //set main nav and close dialog popover
      this.$store.commit('setNav', ['Classes', 'classes']);
      this.$store.commit('instructors/setActiveView', ['Gradebook']);
      this.setDashModal(null);
      //set query params and active view
      this.$store.commit('instructors/resetQueryParams');
      let queryParams = {section_id: data.section.id, playlistGradebook: this.playlist.id};
      //if lms class, turn on query param to true
      if(data.section.lmsType != null && data.lmsType != 'Google' && data.lmsType != 'SchoologyFree' && data.lmsType != 'Clever') queryParams.lms_class = true;
      this.$store.commit('instructors/setQueryParams', queryParams);
      //breadcrumbs
      let payload = {};
      let breadcrumb = [{text:'Playlists', disabled: false, payload:'Playlists'}, {text:data.section.name, payload:''}];
      this.$store.commit('updateBreadCrumbs' , [breadcrumb, payload]);
      this.$store.commit('instructors/setGradebookBreadcrumbs', [{text:this.playlist.name, payload:''}]);
      //get table data, update url
      this.$store.dispatch('instructors/updateUrl');
      this.$store.dispatch('instructors/getTableData');
    },
  },
  mounted() {
    this.getPlaylistMonitorData(this.playlist.id);
  },
};
</script>


